// The single address users are given to reach us. Referenced from the Contact
// page and the Privacy Policy; change it here and both follow.
export const CONTACT_EMAIL = 'contacts@dissona.app';
